import {Injectable} from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';

declare var jQuery: any;

@Injectable()
export class Utils{

	constructor(protected flashMessagesService: FlashMessagesService,
				protected spinnerService: Ng4LoadingSpinnerService) {}
	
  public buildParams(params?: any): URLSearchParams{
    let search = new URLSearchParams();

    if(typeof params !== 'undefined'){
      for (let i in params){
        if(params[i] !== undefined){
          if((i == "criado_em_to" || i == "criado_em_from")){
            let regex: any = /\d\d\/\d\d\/\d\d\d\d/;
            if(!regex.test(params[i]))
              continue;
          }
          search.set(i, params[i]);
        }
      }
    }
    return search;
  }

  public buildFormData(object: any): FormData {
    let formData:FormData = new FormData();

    for(let doc in object){
      if(typeof(object[doc]) === 'object'){
        if(object[doc] instanceof File){
          formData.append(doc,object[doc], object[doc].name );
        } else {
          this.buildFormDataRec(formData, object, doc, doc);
        }
      }else{
        formData.append(doc,object[doc]);
      }
    }

    return formData;
  }

  public ValidarCPF(strCPF: string): boolean {
    let Soma;
    let Resto;
    Soma = 0;
	  if (strCPF == "00000000000") return false;

	  for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

	  Soma = 0;

    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
  }

  private buildFormDataRec(formData:FormData, object:any, index:any, label:any): void{
    for(let i in object[index]){
      // console.log(object[index]);
      if(typeof(object[index][i]) === 'object'){
        let l:string = label+'['+i+']';
        if(object[index][i] instanceof File){
          formData.append(label+'['+i+']',object[index][i], object[index][i].name );
        } else {
          this.buildFormDataRec(formData, object[index], i, l);
        }
      } else {
        formData.append(label+'['+i+']',object[index][i]);
      }
    }
  }

	public exibirMensagem(mensagem: string, tipo: string): void {
		this.flashMessagesService.show(mensagem, {cssClass: 'card alert-' + tipo, timeout: 5000});
		window.scrollTo(0, 0);	
	}
	
	public maskphone(field_id): any {
        let text = jQuery('#'+field_id).val();
        text=text.replace(/\D/g,""); //remove caracteres que não sejam números.

        //Aplica Mascara
        text=text.replace(/(\d{0})(\d)/,"$1($2");   //Coloca ponto entre o terceiro e o quarto dígitos
        text=text.replace(/(\d{2})(\d)/,"$1) $2");   //Coloca ponto entre o setimo e o oitava dígitos
        text=text.replace(/(\d{5})(\d)/,"$1-$2");   //Coloca ponto entre o decimoprimeiro e o decimosegundo dígitos
        text=text.substr(0,15);
        return text;
    }
	
	public handleError(error: any): Promise<any> {
        console.log(error);
		this.spinnerService.hide();
		switch (error.status) {
            case 500:
                this.exibirMensagem('Ocorreu um erro no servidor, entre em contato com o administrador.', 'danger');
                break;
			case 400:
            case 401:
			case 408:
				this.exibirMensagem(error.json().msg, 'danger');
				break;
            case 403:
			case 404:
                this.exibirMensagem(error.json().msg, 'warning');
                break;
			case 422:
                this.exibirMensagem(error.json().msg, 'warning');
                break;	
            default:
				this.exibirMensagem('Ocorreu um erro, tente novamente mais tarde.', 'danger');
        }
        return Promise.reject(error);
    }
	
	handle(resp: any): Promise<any> {
		this.spinnerService.hide();
        switch (resp.status) {
            case 201:
                this.exibirMensagem(resp.json().msg, 'success');
                break;
			case 202:
			case 203:
				this.exibirMensagem(resp.json().msg, 'warning');
				break;
           default:
                this.exibirMensagem(resp.json().msg, 'success');
                break;
        }
        return resp;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils.ts